import { MouseEvent, useState } from "react";
import { Box, Button, Card, CardContent, Popover } from "@mui/material";
import ArrowIcon from "@mui/icons-material/ArrowDropDown";

import colors from "../../../../styles/colors";

function ColorsLegend() {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "colors-legend-popover" : undefined;

  return (
    <>
      <Button
        onClick={handleClick}
        type="button"
        variant="text"
        size="small"
        sx={{
          textTransform: "none",
          color: "rgba(0, 0, 0, 0.87)",
          "& .MuiSvgIcon-root": {
            color: colors.mui.primary,
          },
        }}
      >
        Legenda das cores <ArrowIcon />
      </Button>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Card
          sx={{
            "& .MuiCardContent-root": {
              padding: "0.25rem",
            },
          }}
        >
          <CardContent>
            <Box display="flex" flexDirection="column">
              <Box display="flex" alignItems="center" mb={1}>
                <Box width={20} height={20} bgcolor={colors.lancamento} />
                <Box ml={1}>Produto em Lançamento</Box>
              </Box>
              <Box display="flex" alignItems="center" mb={1}>
                <Box width={20} height={20} bgcolor={colors.promocao} />
                <Box ml={1}>Produto com Desconto</Box>
              </Box>
              <Box display="flex" alignItems="center" mb={1}>
                <Box width={20} height={20} bgcolor={colors.bloqueio} />
                <Box ml={1}>Produto com Bloqueio</Box>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Popover>
    </>
  );
}

export default ColorsLegend;
